import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {
  fetchHeroAddressList,
} from '../../../../modules/heroGroupSelling'
import { ADDRESS_TYPE } from '../../../../utils/constants'
import {
  Card,
  Table,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'

const HeroAddress = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [searchText, setSearchText] = useState('')

  const { heroAddressList, isLoading } = useSelector(
    (state) => ({
      heroAddressList: state.heroGroupSelling.heroAddressList,
      isLoading: state.heroGroupSelling.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchHeroAddressList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).add(543, 'years').format('DD/MM/YYYY HH:mm')
    }
    return date
  }

  const GetStatusColor = (status) => {
    let color = ''
    if (status !== null) {
      switch (status) {
        case 1:
          color = 'green'
          break
        case 2:
          color = 'blue'
          break
        default:
          break
      }
    }
    return color
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'ประเภท',
      dataIndex: 'type',
      key: 'type',
      filters: [
        { text: 'บุคคลธรรมดา', value: 'PERSONAL' },
        { text: 'นิติบุคคล', value: 'CORPORATE' }
      ],
      onFilter: (value, record) => record.type === value,
      render: (type) => {
        return (
          <span>
            {type ? ADDRESS_TYPE[type] : type}
          </span>
        )
      }
    },
    {
      title: 'เลขเสียภาษี',
      dataIndex: 'taxId',
      key: 'taxId',
      ...getColumnSearchProps('taxId'),
      render: (taxId, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={taxId.toString()}
          />
        </div>
      )
    },
    {
      title: 'ชื่อฮีโร่',
      dataIndex: 'hero.name',
      key: 'heroname',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'ชื่อ',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      key: 'address',
      render: (text, record) => <div>{record.address + " " + record.subDistrict + " " + record.district + " " + record.province + " " + record.zipCode}</div>
    },
    {
      title: 'โทร',
      dataIndex: 'tel',
      key: 'tel',
      ...getColumnSearchProps('tel'),
      render: (tel, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={tel.toString()}
          />
        </div>
      )
    },
    {
      title: 'วันที่เพิ่มข้อมูล',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return (
          <span>
            {created}
          </span>
        )
      }
    },
    {
      title: 'วันที่อัพเดทข้อมูล',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: (a, b) => a.updatedAt - b.updatedAt,
      render: (updatedAt) => {
        const update = GetDate(updatedAt)
        return (
          <span>
            {update}
          </span>
        )
      }
    },
    {
      title: 'ประเภทที่อยู่การส่ง',
      key: 'typeAdress',
      filters: [
        { text: 'ที่อยู่หลัก', value: 'ที่อยู่หลัก' },
        { text: 'ที่อยู่ส่งเอกสาร', value: 'ที่อยู่ส่งเอกสาร' },
        { text: 'ที่อยู่หลักและที่อยู่ส่งเอกสาร', value: 'ที่อยู่หลักและที่อยู่ส่งเอกสาร'}
      ],
      filterMultiple: true,
      width: 200,
      onFilter: (value, record) => (record.mainAddress & record.docAddress ? 'ที่อยู่หลักและที่อยู่ส่งเอกสาร' : record.mainAddress ? 'ที่อยู่หลัก' : record.docAddress ? 'ที่อยู่ส่งเอกสาร' : '') === value,
      render: (type, record) => {
        return (
          <span>
            {record.mainAddress & record.docAddress ?
              <div>
                <Tag color={GetStatusColor(1)} key={1}>ที่อยู่หลัก</Tag>
                &nbsp;
                <Tag color={GetStatusColor(2)} key={2}>ที่อยู่ส่งเอกสาร</Tag>
              </div> :
              record.mainAddress ? <Tag color={GetStatusColor(1)} key={1}>ที่อยู่หลัก</Tag> :
                record.docAddress ? <Tag color={GetStatusColor(2)} key={2}>ที่อยู่ส่งเอกสาร</Tag> : ''}
          </span>
        )
      }
    },
  ]

  return (
    <Card
      title="Hero Address"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1300 }}
        rowKey={(record) => record.id}
        dataSource={heroAddressList}
        columns={columns}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(HeroAddress)
